module.exports = __webpack_public_path__ + "img/saved_prints.eeb83bd3.png";